// store/selectors/AuthSelectors.js
export const isAuthenticated = (state) => {
    return !!state.auth.auth.accessToken;
};